import React from "react";
import {Button, Input, InputAdornment} from "@mui/material";
import {ReactComponent as SearchIcon} from "../../assets/icons/search_page_icon.svg";
import {ReactComponent as CloseIcon} from "../../assets/icons/close.svg";
import {isMobile} from "react-device-detect";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    inputSearch: (props: any) => ({
        width: `100%`,
        fontSize: '14px',
        height: props.height,
        lineHeight: `1`,
        backgroundColor: '#ffffff',
        direction: props.direction,
        border: `1px solid #888888`,
        borderRadius: '5px',
        '& button:disabled': {
            opacity: `0.2`,
        }
    })
}))

interface Props {
    onClearSearchInput: VoidFunction;
    onChangeSearchInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
    valueSearchInput: string | number;
    onSubmitSearchInput: (e: any) => void;
    inputHeight: string;
}



export const InputSearch: React.FC<Props> = ({
                                                 onClearSearchInput,
                                                 onChangeSearchInput,
                                                 valueSearchInput,
                                                 onSubmitSearchInput,
                                                 inputHeight,
                                             }) => {
    const flyersBranchData = useSelector((state: IAppState) => state.flyersBranch.data);

    const stylesProperties = {
        direction: flyersBranchData?.dir.toLowerCase(),
        height: inputHeight
    }
    const classes = useStyles(stylesProperties)
    return (
        <form onSubmit={onSubmitSearchInput}>
            <Input
                startAdornment={
                    <InputAdornment position={'start'} sx={{px: isMobile ? '5px' : '10px', mx: '0'}}>
                        <Button type={"submit"} onClick={onSubmitSearchInput}>
                            <SearchIcon />
                        </Button>
                    </InputAdornment>
                }
                endAdornment={
                    <InputAdornment position={'end'} sx={{px: isMobile ? '5px' : '10px', m: '0'}}>
                        <Button onClick={onClearSearchInput} disabled={valueSearchInput === "" && !isMobile}>
                            <CloseIcon />
                        </Button>
                    </InputAdornment>
                }
                // onFocus={onFocus}
                // onBlur={onUnFocusInput}
                onChange={onChangeSearchInput}
                placeholder={``}
                autoFocus={isMobile}
                // placeholder={isHebrewStyle ? "חיפוש" : "Search"}
                type={`text`}
                value={valueSearchInput}
                disableUnderline
                className={classes.inputSearch}
            />
        </form>
    )
}